<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.biao_ti')" prop="title">
              <el-input v-model="form.title" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.nei_rong')" prop="content">
              <el-input type="textarea" :rows="5" v-model="form.content" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.fa_bu_shi_jian')" prop="publishTimer">
              <custom-date-picker v-model="form.publishTimer" type="datetimerange" align="right" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="afterToday"></custom-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.shi_fou_tan_chuang')" prop="isPop">
              <el-switch v-model="form.isPop" :active-value="true" :inactive-value="false"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.tui_song_jue_se')" prop="pushRange">
              <custom-select v-model="form.pushRange" code="bas_org_type" :placeholder="$t('Common.com_please_select')" :multiple="true" :multiple-limit="5" @change="changeSelect($event, 'pushRange')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.tui_song_fan_wei')" prop="pushRole">
              <custom-select
                v-model="form.pushRole"
                url="roleMsgList"
                :props="{ label: 'roleName', value: 'roleCode' }"
                :placeholder="$t('Common.com_please_select')"
                :multiple="true"
                :multiple-limit="5"
                @change="changeSelect($event, 'pushRole')"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_notice_item_dialog.tui_song_qu_dao')" prop="pushChannel">
              <custom-select
                v-model="form.pushChannel"
                code="bas_msg_push_template_type"
                :placeholder="$t('Common.com_please_select')"
                :multiple="true"
                :multiple-limit="5"
                @change="changeSelect($event, 'pushChannel')"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveNotice">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      menuId: '',
      form: {
        title: '',
        isPop: false,
        content: '',
        pushChannel: [],
        pushChannelName: [],
        pushRange: [],
        pushRangeName: [],
        pushRole: [],
        pushRoleName: [],
        beginTime: undefined, // 开始时间
        endTime: undefined, // 结束时间
        publishTimer: undefined, // 发布时间
        noticeId: undefined,
      },
    };
  },
  computed: {
    rules() {
      return {
        title: [
          {
            required: true,
            message: this.$t('base_notice_item_dialog.biao_ti_bi_tian'),
          },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        publishTimer: {
          required: true,
          message: this.$t('base_notice_item_dialog.fbsjbx'),
        },
        isPop: {
          required: true,
          message: this.$t('base_notice_item_dialog.qxzsftc'),
        },
        content: [
          {
            required: true,
            message: this.$t('base_notice_item_dialog.nei_rong_bi_tian'),
          },
          { max: 10000, message: this.$t('Common.com_rules_length_max', [10000]), },
        ],
        pushChannel: {
          type: 'array',
          required: true,
          message: this.$t('base_notice_item_dialog.tsqdbx'),
          trigger: 'blur',
        },
        pushRange: {
          type: 'array',
          required: true,
          message: this.$t('base_notice_item_dialog.tsjsbx'),
          trigger: 'blur',
        },
        pushRole: {
          type: 'array',
          required: true,
          message: this.$t('base_notice_item_dialog.tsfwbx'),
          trigger: 'blur',
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.getDictionary('bas_msg_push_template_type,bas_org_type');
      if (this.model.type === 'edit') {
        this.form.noticeId = this.model.id;
        this.getNoticeInfo();
      }
    },
    // 获取编辑信息
    getNoticeInfo: function () {
      this.$getJSON(`${apis.noticeInfo}/${this.model.id}`).then((res) => {
        this.form = res.data;
        this.$set(this.form, 'publishTimer', [this.form.beginTime, this.form.endTime]);
      });
    },
    // 下拉选择多参数赋值
    changeSelect: function (item, key) {
      if (key === 'pushRole') {
        this.form.pushRoleName = item.map((t) => t.roleName);
      }
      if (key === 'pushRange') {
        this.form.pushRangeName = item.map((t) => t.name);
      }
      if (key === 'pushChannel') {
        this.form.pushChannelName = item.map((t) => t.name);
      }
    },
    // 确认保存菜单
    saveNotice: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // 时间
        this.form.beginTime = this.form.publishTimer && this.form.publishTimer[0] ? this.form.publishTimer[0] : undefined;

        this.form.endTime = this.form.publishTimer && this.form.publishTimer[1] ? this.form.publishTimer[1] : undefined;
        if (this.model.type === 'add') {
          this.saveAddNotice();
        }
        if (this.model.type === 'edit') {
          this.saveEditNotice();
        }
      });
    },
    // 保存新增菜单
    saveAddNotice: function () {
      this.$postJSON(apis.noticeAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditNotice: function () {
      this.$postJSON(apis.noticeEdit, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
